declare const window: any;
export const dispatchEvent = (params: any) => {
    if (typeof window !== "undefined" && window.dataLayer !== "undefined")
        window?.dataLayer?.push({ ...params });
};
